import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { thunks } from "@/lib/redux/thunks"
import { track } from "@/lib/tracking"
import { useParams, useSearchParams } from "next/navigation"
import { useEffect } from "react"

export let calledToursByCategory: any = {}

export const useToursByCategory = () => {
  const tours = useAppSelector(state => state.tour.tours_search)
  const vendorCode = useAppSelector(state => state.tour.formSearch.vendorCode)
  const dispatch = useAppDispatch()

  const params: any = useParams()
  const searchParams = useSearchParams()

  useEffect(() => {
    const startDate = searchParams.get('start_date')
    if (!params?.categoryId || calledToursByCategory[`${params?.categoryId}${vendorCode}${startDate}`]) return
    calledToursByCategory = {
      [`${params?.categoryId}${vendorCode}${startDate}`]: true
    }
    // DOP-925: tour_search — cover điều hướng vào trang category (từ nút search
    // category khác hoặc vào thẳng URL); case cùng category track ở ButtonSearch
    track('tour_search', {
      category_id: params?.categoryId,
      travel_date: startDate || undefined,
    })
    dispatch(thunks.tours_search({
      params: {
        category_id: params?.categoryId,
        vendor_code: vendorCode,
        start_date: startDate,
        search_mode: 1
      }
    }))  
  }, [params?.categoryId, vendorCode])

  return tours
}